/**
 * Inline tool-activity block for agent chat (SS 8.8).
 *
 * Renders one or more tool calls as compact status lines within the
 * chat thread. Each call shows an icon, the tool name in plain
 * language, and a summary once the result arrives.
 *
 * Visually distinct from persona text: smaller font, muted colour,
 * collapsible via a <details> element. Auto-collapses once all
 * activities in the block are complete.
 */

const TOOL_ICONS = {
  web_search: "\uD83C\uDF10",
  search_project_documents: "\uD83D\uDD0D",
  read_project_document: "\uD83D\uDCC4",
  save_document: "\uD83D\uDCBE",
};

function describeToolCall(tool, input) {
  switch (tool) {
    case "web_search":
      return `Searching the web for "${input?.query || "..."}"`;
    case "search_project_documents":
      return `Searching project documents for "${input?.query || "..."}"`;
    case "read_project_document":
      return `Reading ${input?.filename || "document"}`;
    case "save_document":
      return `Saving ${input?.filename || "document"}`;
    default:
      return `Running ${tool}`;
  }
}

export default function ToolActivity({ activities }) {
  if (!activities || activities.length === 0) return null;

  const anyRunning = activities.some((a) => a.status === "running");

  return (
    <div className="tool-activity">
      <details open={anyRunning}>
        <summary className="tool-activity-header">
          {activities.length === 1 ? "1 tool used" : `${activities.length} tools used`}
        </summary>
        <div className="tool-activity-list">
          {activities.map((a) => (
            <div key={a.toolUseId} className="tool-activity-item">
              <span className="tool-activity-icon">
                {TOOL_ICONS[a.tool] || "\u2699\uFE0F"}
              </span>
              <span className="tool-activity-desc">
                {describeToolCall(a.tool, a.input)}
              </span>
              {a.status === "running" && (
                <span
                  className="tool-activity-spinner"
                  role="status"
                  aria-label="Running"
                />
              )}
              {a.status === "done" && a.summary && (
                <span className="tool-activity-result">
                  {"\u2192"} {a.summary}
                </span>
              )}
            </div>
          ))}
        </div>
      </details>
    </div>
  );
}
